"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); // @ts-ignore

if (!global.fetch) {
  require('isomorphic-fetch');
} // @ts-ignore


if (!global.FormData) {
  // @ts-ignore
  global.FormData = require('form-data');
}

var auth_1 = require("./auth");

exports.auth = auth_1.default;

var data_1 = require("./data");

exports.data = data_1.default;

var pay_1 = require("./pay");

exports.pay = pay_1.default;

var storage_1 = require("./storage");

exports.storage = storage_1.default;